export default __webpack_public_path__ + "static/media/0000..0003.55822b82.png";